export default __webpack_public_path__ + "static/media/Mercenary's Leggings of the Primeval.e0debec8.jpg";